import React from "react";

export default function Supervisione() {
  return (
    <>
      <section id="supervisione" className="faq section-bg">
        <div className="container">
          <div className="section-title">
            <h2>Supervisione</h2>
            <p>Supervisione e Percorsi di Counseling</p>
          </div>

          <div className="row content">
            <div className="col-md-8 pt-4 order-2 order-md-1">
              <p>
                Spazi dedicati a chi lavora ogni giorno come Logopedista e
                desidera sentirsi più centrata, efficace e serena, nella
                professione come nella vita.
              </p>

              <div className="faq-list content">
                <ul>
                  <li>
                    <a
                      data-bs-toggle="collapse"
                      className="collapse supervision collapsed"
                      data-bs-target="#sup-list-1"
                    >
                      Supervisione professionale (1 incontro)
                      <i className="bx bx-chevron-down icon-show"></i>
                      <i className="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="sup-list-1" className="collapse">
                      <p>
                        Un primo passo per conoscerci e verificare quanto un
                        confronto mirato possa alleggerire ciò che pesa e
                        migliorare ciò che vuoi potenziare nel tuo lavoro.
                      </p>
                      <p>
                        Ideale se vuoi:
                        <div className="details">
                          <div className="content p-3">
                            <ul>
                              <li className="sup-li">
                                fare chiarezza su una situazione professionale
                                che non ti è ben chiaro come gestire e vuoi un
                                confronto strutturato per individuare strategie
                                efficaci, in piena riservatezza
                              </li>
                              <li className="sup-li">
                                lavorare su casi clinici e ricevere indicazioni
                                operative per valutazione, riabilitazione e
                                metodo di studio in ambito *DSA* (mi occupo di
                                clinica e formazione in quest'ambito da oltre 20
                                anni), integrando sempre la dimensione
                                relazionale
                              </li>
                            </ul>
                          </div>
                        </div>
                      </p>
                      <p>Costo: 61,20€</p>
                    </div>
                  </li>

                  <li>
                    <a
                      data-bs-toggle="collapse"
                      className="collapse supervision collapsed"
                      data-bs-target="#sup-list-2"
                    >
                      Counseling psicologico (percorso da 3 incontri)
                      <i className="bx bx-chevron-down icon-show"></i>
                      <i className="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="sup-list-2" className="collapse">
                      <p>
                        La sensibilità, fondamentale nel lavoro, può diventare
                        una fatica e trasformarsi in irritabilità, rabbia,
                        scarsa energia e in quel peso che ti segue anche fuori
                        dal setting. Questo percorso ti aiuta a individuare il
                        punto che “punge” e a prendertene cura con delicatezza e
                        concretezza, rinforzando i confini professionali e
                        personali.
                      </p>
                      <p>
                        Ideale se vuoi:
                        <div className="details">
                          <div className="content p-3">
                            <ul>
                              <li className="sup-li">
                                gestire un fastidio o una confusione che ti sta
                                sottraendo energia
                              </li>
                              <li className="sup-li">
                                ritrovare centratura e confini, senza
                                irrigidirti né sentirti in colpa o "non
                                abbastanza"
                              </li>
                              <li className="sup-li">
                                prevenire accumulo di stress e rientrare a casa
                                con più serenità
                              </li>
                            </ul>
                          </div>
                        </div>
                      </p>
                      <p>Costo: 182€ </p>
                    </div>
                  </li>

                  <li>
                    <a
                      data-bs-toggle="collapse"
                      className="collapse supervision collapsed"
                      data-bs-target="#sup-list-3"
                    >
                      Counseling psicologico (percorso da 5 incontri)
                      <i className="bx bx-chevron-down icon-show"></i>
                      <i className="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="sup-list-3" className="collapse">
                      <p>
                        Uno spazio di crescita: sicuro, accogliente, orientato
                        al cambiamento. Qui puoi esplorare temi personali e
                        professionali importanti, sperimentare ascolto attivo e
                        feedback, e individuare aree di potenziamento. Un
                        percorso breve ma denso, per intravedere nuove
                        possibilità e iniziare a muoverti con più libertà in
                        direzione dei tuoi desideri.
                      </p>
                      <p>
                        Ideale se vuoi:
                        <div className="details">
                          <div className="content p-3">
                            <ul>
                              <li className="sup-li">
                                lavorare su nodi ricorrenti (insicurezze,
                                perfezionismo, difficoltà relazionali, gestione
                                dei confini, stati di ansia e affaticamento)
                              </li>
                              <li className="sup-li">
                                aumentare consapevolezza, efficacia comunicativa
                                e solidità emotiva
                              </li>
                              <li className="sup-li">
                                trasformare un “blocco” in un’area di sviluppo
                                concreta
                              </li>
                            </ul>
                          </div>
                        </div>
                      </p>
                      <p>Costo: 292€ </p>
                    </div>
                  </li>

                  <li>
                    <a
                      data-bs-toggle="collapse"
                      className="collapse supervision collapsed"
                      data-bs-target="#sup-list-4"
                    >
                      Counseling psicologico (Percorso da 8 incontri)
                      <i className="bx bx-chevron-down icon-show"></i>
                      <i className="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="sup-list-4" className="collapse">
                      <p>
                        Per chi vuole un lavoro più profondo e continuativo: un
                        percorso su misura per affrontare con maggiore
                        consapevolezza ed efficacia sfide personali e
                        professionali. Lavoriamo su benessere emotivo, gestione
                        dello stress, dinamiche relazionali e crescita
                        personale, con strumenti pratici e un approccio empatico
                        fondato sulla buona comunicazione.
                      </p>
                      <p>
                        Ideale se vuoi:
                        <div className="details">
                          <div className="content p-3">
                            <ul>
                              <li className="sup-li">
                                ridurre stress e sovraccarico emotivo con un
                                piano personalizzato
                              </li>
                              <li className="sup-li">
                                migliorare la qualità delle relazioni personali
                                (partner, famiglia d'origine, amicizia) e
                                professionaole (pazienti, caregiver, colleghi)
                              </li>
                              <li className="sup-li">
                                sentirti più stabile, forte e soddisfatta nel
                                lavoro come nella vita
                              </li>
                            </ul>
                          </div>
                        </div>
                      </p>
                      <p>Costo: 450€ </p>
                    </div>
                  </li>
                </ul>
              </div>

              <section id="pricing" className="pricing pt-4 pb-4">
                <div className="row content">
                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Dove?</h3>
                      <div>
                        <strong>Online</strong>
                        <br />
                        piattaforma Zoom
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                   
                                  </div> */}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Come?</h3>
                      <div>
                        Scrivi a:
                        <br />
                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>
                          <strong>{process.env.REACT_APP_EMAIL}</strong>
                        </a>
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                           
                                  </div> */}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="col-md-4 order-1 order-md-2">
              <img
                src="assets/img/site/1/supervisione.jpeg"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
